/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Pending_RequestsInputs */

const en_document_pending_requests = /** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Requests`)
};

const id_document_pending_requests = /** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan Tertunda`)
};

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const es_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const fr_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const de_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const ja_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const zh_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const ar_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const it_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const ru_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const pt_document_pending_requests = en_document_pending_requests;

/** @type {(inputs: Document_Pending_RequestsInputs) => LocalizedString} */
const ko_document_pending_requests = en_document_pending_requests;

/**
* | output |
* | --- |
* | "Pending Requests" |
*
* @param {Document_Pending_RequestsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_pending_requests = /** @type {((inputs?: Document_Pending_RequestsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Pending_RequestsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_pending_requests(inputs)
	if (locale === "es") return es_document_pending_requests(inputs)
	if (locale === "fr") return fr_document_pending_requests(inputs)
	if (locale === "de") return de_document_pending_requests(inputs)
	if (locale === "ja") return ja_document_pending_requests(inputs)
	if (locale === "zh") return zh_document_pending_requests(inputs)
	if (locale === "ar") return ar_document_pending_requests(inputs)
	if (locale === "id") return id_document_pending_requests(inputs)
	if (locale === "it") return it_document_pending_requests(inputs)
	if (locale === "ru") return ru_document_pending_requests(inputs)
	if (locale === "pt") return pt_document_pending_requests(inputs)
	return ko_document_pending_requests(inputs)
});